/**
 * Utility functions for formatting outlet names
 */

interface FormatOptions {
  shorten?: boolean;
}

/**
 * Formats an outlet name with optional shortening
 * @param name - The outlet name to format
 * @param options - Formatting options
 * @param options.shorten - If true, shortens name to 15 characters with ellipsis
 * @returns Formatted outlet name
 */
export function formatOutletName(name: string, options: FormatOptions = {}): string {
  if (!name) return '';
  
  // Apply shortening if requested (preserve original capitalization)
  if (options.shorten && name.length > 15) {
    return name.substring(0, 15) + '...';
  }
  
  return name;
}